import React, { useState } from "react";
import { Upload, Modal } from "antd";
import UploadIcon from "../../../../image/uploadadd.svg";
import Trash from "../../../../image/trash.svg";
import PreView from "../../../../image/big.svg";
import { uploadSoftInfo } from "../../../../service/register";
import { message } from "../../../../components/Message";
import styles from "../../../../components/Upload/index.modules.less";

/** 支持嵌套 fieldPath 的图片上传（intl Register 扩展语言 Tab） */
const IntlImageUpload = ({
  maxCount,
  tips,
  fileList,
  name,
  fieldPath,
  form,
  accept,
  width,
  height,
  size,
}) => {
  const syncFileList = (newFileList) => {
    if (fieldPath?.length) {
      form.setFieldValue(fieldPath, newFileList);
      return;
    }
    form.setFieldsValue({ [name]: newFileList });
  };

  function customRequest(option) {
    const reader = new FileReader();
    reader.readAsDataURL(option.file);
    reader.onloadend = function (event) {
      if (event?.target?.result) {
        const base64Data = event.target.result.replace(
          /^data:image\/(jpeg|png|gif);base64,/,
          ""
        );
        uploadSoftInfo({ pic_base64: base64Data })
          .then((res) => option.onSuccess(res))
          .catch((error) => {
            option.onError(error);
            message.show({ type: "error", content: "上传错误" });
          });
      }
    };
  }

  async function handleBeforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.show({ type: "error", content: "上传类型为 JPG/PNG" });
      return Upload.LIST_IGNORE;
    }
    const isGtLimit = file.size / 1024 / 1024 > size;
    if (isGtLimit) {
      message.show({ type: "error", content: `图片不能大于${size}M!` });
      return Upload.LIST_IGNORE;
    }

    if (width && height) {
      const validSize = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = function (event) {
          const image = new Image();
          image.onload = function () {
            if (image.width !== width || image.height !== height) {
              message.show({ type: "error", content: "图片宽高设置不正确!" });
              resolve(false);
              return;
            }
            resolve(true);
          };
          image.src = event.target.result;
        };
      });
      if (!validSize) {
        return Upload.LIST_IGNORE;
      }
    }

    return true;
  }

  const [preview, setPreview] = useState({
    isOpen: false,
    seeImage: "",
    setTitle: "",
  });

  const CustomItemRender = (originNode, file, currentFileList, actions) => {
    if (file?.status !== "done") {
      return originNode;
    }
    return (
      <div className="custom-item-renderer">
        <img src={file?.response?.pic_url} alt={file.name} />
        <div className="buttons flex mt-1 ">
          <div className="mask-r">
            <div
              onClick={() =>
                setPreview({
                  isOpen: true,
                  seeImage: file?.response?.pic_url,
                  setTitle: file.name,
                })
              }
            >
              <PreView className="mask-icon preview" width="15" height="15" />
            </div>
            <div onClick={() => actions.remove(currentFileList)}>
              <Trash className="mask-icon" width="15" height="15" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleOnChange = (info) => {
    let newFileList = [...info.fileList];
    newFileList = newFileList.map((file) => {
      if (file.response) {
        file.url = file.response.pic_url;
      }
      return file;
    });
    syncFileList(newFileList);
  };

  return (
    <>
      <Upload
        className="custom_upload"
        onChange={handleOnChange}
        itemRender={CustomItemRender}
        listType="picture-card"
        customRequest={customRequest}
        beforeUpload={handleBeforeUpload}
        fileList={fileList}
        accept={accept}
      >
        {fileList?.length >= maxCount ? null : (
          <div className={styles.uploadCt}>
            <div className={styles.UploadIcon}>
              <UploadIcon />
            </div>
            <div className={styles.uploadText}>点击添加图片</div>
          </div>
        )}
      </Upload>
      <div className={styles.uploadTips}>{tips}</div>
      <Modal
        open={preview.isOpen}
        title={preview.setTitle}
        footer={null}
        onCancel={() => setPreview({ isOpen: false, seeImage: "", setTitle: "" })}
      >
        <img style={{ width: "100%" }} src={preview.seeImage} alt="preview" />
      </Modal>
    </>
  );
};

export default IntlImageUpload;
